import React, { useEffect } from "react";
// import BlogSection from "../../components/home/Blog";
import { Helmet } from "react-helmet-async";
import BlogSection from "../../components/home/Blog";
import CaseStudy from "../../components/home/CaseStudy";
import OurStrengthSection from "../../components/home/OurStrength";
import ProductSection from "../../components/home/Product";
import ServiceSection from "../../components/home/Service";
import HeroBannerSeection from "../../components/home/SliderCarousel/HeroBannerSeection";
import Popup from "../../components/modals/popup";
import News from "../../components/home/News";

export default function TestNews() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>グローバルジャパンネットワーク | Global Japan Network</title>
        <meta property="og:title" content="グローバルジャパンネットワーク | Global Japan Network" />
        {/* <meta property="og:description" content="グローバルジャパンネットワークは、インドの優秀なIT人材によるオフショアモバイル・Androidアプリ開発でコスト削減と高品質を実現します。" /> */}
        <meta property="og:url" content="https://gjnetwork.jp" />
        <meta property="og:image" content="https://gjnetwork.jp/img/global-japan-og-img.jpg" />
        <link rel="canonical" href={`https://gjnetwork.jp${window.location.pathname}`} />
      </Helmet>
      {/* <Carousel/> */}
      <HeroBannerSeection />
      <OurStrengthSection />
      <ProductSection />
      <ServiceSection isHide={true} />
      <CaseStudy />
      <BlogSection />
      <News />
      <Popup />
    </>
  );
}
